import styles from "./upgrade_banner.module.scss"

import icon from "images/web/browse/arrow-right.svg?raw"
import parse from "html-react-parser"
import { tierDisplayName } from "shared/utils/tiers"

interface Props {
  appletTier: "free" | "intermediate_pro" | "legacy_pro" | "pro"
  ctaReason: string
  eligibleForTrial: boolean
  eligibleTrialPeriod?: number
  onClick: () => void
}

const UpgradeBanner = ({ appletTier, ctaReason, eligibleForTrial, eligibleTrialPeriod, onClick }: Props) => {
  let content = ""
  let cta = ""

  if (ctaReason === "applet_quota") {
    if (eligibleForTrial) {
      content = `You have reached your Applet limit. Try IFTTT Pro free for ${eligibleTrialPeriod || 7} days and get 20 Applets.`
      cta = "Start for free"
    } else {
      content = "You have reached your Applet limit. IFTTT Pro users get 20 Applets."
      cta = "Upgrade now"
    }
  } else {
    content = `This Applet uses features only available to ${tierDisplayName(appletTier)} users. You need to upgrade to enable this Applet.`
    cta = "Upgrade for more features"
  }

  return (
    <a onClick={onClick} className={styles["upgrade-banner"]}>
      <span>{content}</span>
      <button className="button-tertiary button-outlined button-on-color">
        {cta}
        {parse(icon)}
      </button>
    </a>
  )
}

export default UpgradeBanner
